

function TechTag({tagText}) {
    return (
        <span className="inline-block border-2 border-blue-700 rounded-lg px-1 py-0.5 bg-customblack text-customwhite font-semibold mr-2 mb-2 lg:mb-0 decoration-clone">{tagText}</span>
    );
  }
  
  export default TechTag;
  